import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Spinner,
  Pagination,
} from "react-bootstrap";
import { FaAngleLeft, FaAngleRight, FaBasketShopping } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProducts,
  setCurrentPage,
  setCountPerPage,
} from "../../redux/slices/productSlice";
import { Link } from "react-router-dom";
import ProductImg from "../../assets/images/card-img.jpg";

const ProductCard = () => {
  const dispatch = useDispatch();
  const {
    items,
    filteredItems,
    loading,
    error,
    currentPage,
    totalPages,
    countPerPage,
  } = useSelector((state) => state.products);
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchProducts({ page: currentPage, limit: countPerPage }));
  }, [dispatch, currentPage, countPerPage]);

  const handlePageChange = (pageNumber) => {
    dispatch(setCurrentPage(pageNumber));
    dispatch(fetchProducts({ page: pageNumber, limit: countPerPage }));
  };

  if (loading)
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );

  if (error)
    return (
      <div className="text-center py-5 text-danger">
        <p>Error: {error}</p>
      </div>
    );

  return (
    <section className="productcard-section">
      <Container>
        <div className="section-title">
          <div className="sub-title">
            <FaBasketShopping />
            <h4>Our Products</h4>
          </div>
          <h3 className="title">Next Level Pro Quality</h3>
        </div>

        <div className="productcard-list">
          <Row>
            {(filteredItems || items).map((item) => {
              const stock =
                (item.prod_stockqty1 || 0) +
                (item.Prod_stockqty2 || 0) +
                (item.Prod_stockqty3 || 0);

              return (
                <Col key={item.PROD_UID} lg={3} md={6} sm={6}>
                  <div className="productcard">
                    <Link
                      to={`/product/${item.PROD_UID}`}
                      className="productcard-link"
                    >
                      <div className="productcard-img">
                        <img
                          src={item.image_url ? item.image_url : ProductImg}
                          alt={item.PROD_NAME}
                          loading="lazy"
                        />
                        {stock <= 0 ? (
                          <div className="productcard-img-overlay">
                            <p>Out Of Stock</p>
                          </div>
                        ) : (
                          <div className="productcard-img-overlay2">
                            <p>In Stock : {stock} QTY</p>
                          </div>
                        )}
                      </div>
                      <div className="productcard-content">
                        <h3 className="productcard-title">{item.PROD_NAME}</h3>
                        <p className="productcard-description">
                          {item.PROD_DESC}
                        </p>
                      </div>
                    </Link>
                    <div className="productcard-footer">
                      {!token ? (
                        <Link to="/login" className="productcard-button">
                          Login to View Price
                        </Link>
                      ) : (
                        <h5 className="productcard-price">{item.cost}</h5>
                      )}
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>

        {/* --- Updated Pagination --- */}
        <div className="pagination-content">
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <FaAngleLeft />
            </Pagination.Prev>

            {currentPage > 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                {currentPage > 4 && <Pagination.Ellipsis disabled />}
              </>
            )}

            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(
                (page) => page >= currentPage - 2 && page <= currentPage + 2
              )
              .map((page) => (
                <Pagination.Item
                  key={page}
                  active={page === currentPage}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </Pagination.Item>
              ))}

            {currentPage < totalPages - 2 && (
              <>
                {currentPage < totalPages - 3 && <Pagination.Ellipsis disabled />}
                <Pagination.Item
                  onClick={() => handlePageChange(totalPages)}
                >
                  {totalPages}
                </Pagination.Item>
              </>
            )}

            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <FaAngleRight />
            </Pagination.Next>
          </Pagination>
        </div>
      </Container>
    </section>
  );
};

export default ProductCard;
